import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { GlobalConstants } from '../../../../app/common/constants/global.constant';
import { PromoContent, PromoContentConfiguration } from '../../asset-library/promo-content/interfaces/promo-content.i';
import { FACT_TAGS } from './../../../common/constants/fact-tags.constant';
import { CommonService } from './../../../common/services/common.service';
import { CreateProfileService } from './../../../core/routing/services/profile/create-profile.service';
import { factTagsEnum } from '../../../common/constants/fact-tags-names.constant';
import { ProfileUpdateResponse } from '../interface/profile.i';
import { ProfileStoreService } from '../store/profile.store';
@Component({
  selector: 'iposcen-fact-tags',
  templateUrl: './fact-tags.component.html',
  styleUrls: ['./fact-tags.component.scss']
})
export class FactTagsComponent implements OnInit, OnDestroy {
  inActive: string;
  profileID: string;
  isChecked: boolean;
  isPromoFactTagExist: boolean;
  factTags = [];
  factTagFilter = [];
  allPromoContentGroups: PromoContent[];
  profileDataResponse: ProfileUpdateResponse;
  configurations: PromoContentConfiguration[];
  displayPromoContentGroups = [];
  mediaObjects = [];
  contentGrpData = {} as any;
  factTagsEnum = factTagsEnum;
  factTagsJson = [...FACT_TAGS];
  factTagsConst = [];
  processor = GlobalConstants.FACTTAGS_PROCESSOR;
  memory = GlobalConstants.FACTTAGS_MEMORY_OPTANE_MESSAGING;
  optaneMemory = GlobalConstants.MEMORY;
  skip = GlobalConstants.SKIP;
  send = GlobalConstants.SEND;
  factTagsForProfile: any;
  factTagsRemoved: any;
  promosForProfile: any;
  showOnDeviceCount = 0;
  isHungarian = localStorage.getItem('preferredLanguage') === 'hu';
  profileNameValue = GlobalConstants.PROFILE_NAME_LOWER_CASE;
  promoPosition = GlobalConstants.PROMO_FACTTAG_ORDER_DESC;
  private ngUnsubscribe = new Subject<boolean>();

  constructor(private cmnService: CommonService,
    private profileStoreService: ProfileStoreService,
    private createProfileService: CreateProfileService
  ) { }

  ngOnInit(): void {
    this.profileID = this.createProfileService.getProfileId();
    this.factTagsJson = JSON.parse(JSON.stringify(this.factTagsJson));
    this.factTagsJson.forEach(element => {
      this.factTagsConst.push(element);
    });
    this.factTagsConst.forEach(factTag => {
      if (factTag.values.name === '') {
        factTag.values.name = this.factTagsEnum[factTag.name];
      }
      this.factTags.push(factTag);
    });
    this.getPromoContents();

  }

  dropFactTags(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.factTags, event.previousIndex, event.currentIndex);
    this.assignPositionToPromo(false);
  }

  trackByFactTags(index: number, el: string): number {
    return index;
  }

  checkMemory(index, event: any, name: string) {
    if (name === this.optaneMemory) {
      if (event.target.checked) {
        const factTagMemory = this.factTags.filter(factTag => factTag.values.name === GlobalConstants.FACTTAGS_MEMORY_OPTANE_MESSAGING);
        factTagMemory[0].show = true;
        factTagMemory[0].required = true;
        factTagMemory[0].values.optane_messaging = true;
        const factTagOptaneMemory = this.factTags.filter(factTag => factTag.values.name === GlobalConstants.FACTTAGS_INTEL_OPTANE_MEMORY);
        factTagOptaneMemory[0].show = false;
        factTagOptaneMemory[0].required = true;
        this.isChecked = true;
        if (factTagMemory) {
          this.factTags[index].show = true;
        } else {
          this.factTags[index].show = false;
        }

      } else {
        const factTagMemory = this.factTags.filter(factTag => factTag.values.name === GlobalConstants.FACTTAGS_MEMORY_OPTANE_MESSAGING);
        factTagMemory[0].required = false;
        factTagMemory[0].show = true;
        factTagMemory[0].values.optane_messaging = false;
        const factTagOptaneMemory = this.factTags.filter(factTag => factTag.values.name === GlobalConstants.FACTTAGS_INTEL_OPTANE_MEMORY);
        factTagOptaneMemory[0].show = true;
        factTagOptaneMemory[0].required = false;
        this.isChecked = false;
        if (factTagMemory) {
          this.factTags[index].show = true;
        } else {
          this.factTags[index].show = false;
        }

      }
    } else if (name === GlobalConstants.MEMORY_WITHOUT_OPTANE) {
      const factTagMemory = this.factTags.filter(factTag => factTag.values.name === GlobalConstants.FACTTAGS_MEMORY_OPTANE_MESSAGING);
      if (event.target.checked) {
        factTagMemory[0].show = true;
      } else {
        factTagMemory[0].show = false;
      }
    } else {
      this.factTags[index].show = event.target.checked;
    }
  }

  assignPositionToPromo(applySort: boolean) {
    let posIndex = 1;
    let data: any[]; 
    if (!applySort) data = this.factTags; else data = this.factTags.sort((x, y) => y.values.show_on_device - x.values.show_on_device);
    data.forEach(element => {
      if (element.values.show_on_device == false) element.position = 0;
      if (element.values.type === 'StorePromo' && element.values.show_on_device) {
        this.showOnDeviceCount = posIndex;
        element.position = posIndex;
        posIndex++;
      }
    });
  }

  getPromoContents() {
    this.createProfileService.getUpdatedProfileById(this.profileID)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getProfileResponse => {
        this.allPromoContentGroups = (getProfileResponse.profile.promotionalContents as PromoContent[]);
        this.isPromoFactTagExist = (this.allPromoContentGroups !== undefined) ? true : false;
        this.configurations = [];
        if (this.allPromoContentGroups) {
          this.allPromoContentGroups.forEach(promoContentGroup => {
            this.configurations.push(JSON.parse(promoContentGroup.configurations) as PromoContentConfiguration);
          });
        }
        this.displayPromoContentGroups = [];
        if (this.allPromoContentGroups) {
          this.allPromoContentGroups.forEach(ele => {
            ele.configurations = JSON.parse(ele.configurations);
              this.displayPromoContentGroups.push(ele);
          });
        }
        this.profileDataResponse = this.profileStoreService.currentWorkingProfile;
        if (this.profileDataResponse?.factTags && (this.profileDataResponse?.profileId === this.createProfileService.getProfileId())) {
          this.factTagsForProfile = [];
          this.factTagsForProfile = this.profileDataResponse?.factTags;
        }

        if (this.profileDataResponse?.factTags) {
          this.factTags = [];
          const factTagsResponse = JSON.parse(this.factTagsForProfile);
          factTagsResponse
            .forEach(facts => {
              /**  Language fix - start */
              if (facts.values.name !== '') {
                facts.values.name = this.factTagsEnum[facts.name] ? this.factTagsEnum[facts.name] : facts.values.name;
              }
              /**  Language fix - end */
              facts.show = facts.name == 'vr' ? false : facts.show;
              if(facts.name === "memory"){
                facts.required=false;
              }                 
              if(facts.name !== 'camera' && facts.name !== 'optane_memory'){
                this.factTags.push(facts);
              }
            });
        }
        /** if then added promotional contents as fact tags after first save (EDIT) */
        if (this.profileDataResponse && this.profileDataResponse.promotionalContents) {
          if (this.profileDataResponse.factTags) {
            const factTagArray = JSON.parse(this.factTagsForProfile);
            //Below block is to update a content group from facttags dataset if user modifies (Add to Package/Show On Device) selections.
            var i = this.factTags?.length;
            let showOnDeviceClicked = false;
            while (i--) {
              if (this.factTags[i]?.values?.type === "StorePromo") {
                let remove = true;
                for (let each of this.displayPromoContentGroups) {
                  if (each.promotionalContentId === this.factTags[i]?.name) {
                    if (each.showOnDevice !== this.factTags[i]?.values?.show_on_device) {
                      remove = false;
                      showOnDeviceClicked = true;
                      this.factTags[i].values.show_on_device = each.showOnDevice;
                    } else {
                      remove = false;
                      break;
                    }
                  }
                }
                if (remove) {
                  this.factTags.splice(i, 1);
                  this.assignPositionToPromo(true);
                }
              }
            }

            if (showOnDeviceClicked) this.assignPositionToPromo(true);
            const promoList = this.displayPromoContentGroups.sort((a, b) => b.showOnDevice - a.showOnDevice);
            let count = 1;
            promoList.forEach((promos, i) => {
              let exists = false;
              if (promos.showOnDevice) {
                this.showOnDeviceCount = count;
                count++;
              }
              for (let facts of factTagArray) {
                if (facts.name === promos.promotionalContentId) {
                  exists = true;
                  break;
                }
              }

              /** if promotional contents not exists will be added to the fact tags */
              if (!exists) {
                const factTagList = {
                  pin: false,
                  position: promos.showOnDevice ? i + 1 : 0,
                  show: true,
                  name: promos.promotionalContentId,
                  required: false,
                  priority: 18,
                  can_edit: true,
                  updated_at: '',
                  values: {
                    display_text: '',
                    type: 'StorePromo',
                    version: '',
                    name: promos.configurations.publishedName,
                    show_on_device: promos.showOnDevice,
                  },
                  exclude: false,
                  enumVal: ''
                };
                this.factTags.push(factTagList);
                this.assignPositionToPromo(true);
              }
            });
          } else {
            this.displayPromoContentGroups.forEach(contentGroup => {
              if (contentGroup.showOnDevice) {
                if (contentGroup.configurations.publishedName.length) {
                  const factTagList = {
                    pin: false,
                    show: contentGroup.showOnDevice,
                    name: contentGroup.promotionalContentId,
                    required: false,
                    priority: 18,
                    can_edit: true,
                    updated_at: '',
                    values: {
                      display_text: '',
                      device: '',
                      type: 'StorePromo',
                      version: '',
                      name: contentGroup.configurations.publishedName
                    },
                    exclude: false,
                    enumVal: ''
                  };
                  this.factTags.push(factTagList);
                }
              }
            });
          }
        }
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  sendToProfile(action: string) {
    if (action === GlobalConstants.SEND) {
      this.factTags.forEach((factTag, index) => {
        if (factTag.priority !== 1) {
          factTag.priority = index + 1;
        }
      });
      this.cmnService.emitDataToProfile({ page: GlobalConstants.FACT_TAG, dataSet: JSON.stringify(this.factTags) });
      // gtm(google tag manager)
      window['dataLayer'].push({
        'fact_tag_added': true
      });
    } else {
      this.cmnService.emitDataToProfile({ page: GlobalConstants.FACT_TAG, dataSet: GlobalConstants.SKIP });
    }
    this.cmnService.scrollTopInitial();

  }
}
